import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { useAtomsDevtools } from 'jotai-devtools'

import { ThemeProvider } from 'styled-components'
import { BrowserRouter } from 'react-router-dom'

import { config } from 'config'

import { ViewportProvider } from 'contexts/viewport/viewportContext'

import { Routes } from 'router'

import { themeSelector } from './themes'
import Hotjar from '@hotjar/browser'

import { GlobalStyle } from 'themes/globalStyle'

const siteId = 3098872
const hotjarVersion = 6

Hotjar.init(siteId, hotjarVersion)

if (config.DISABLED_CONSOLE_MSG) {
  console.log = () => {}
  console.warn = () => {}
  //console.error = () => {}
}

if (!!window.ethereum) window.ethereum.autoRefreshOnNetworkChange = false

const AtomsDevtools = ({ children }) => {
  useAtomsDevtools('yolorektAtoms')
  return children
}

ReactDOMClient.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={themeSelector('steelMoon')}>
      <GlobalStyle />
      <ViewportProvider>
        <BrowserRouter>
          <AtomsDevtools>
            <Routes />
          </AtomsDevtools>
        </BrowserRouter>
      </ViewportProvider>
    </ThemeProvider>
  </React.StrictMode>
)
